import { useState } from "react";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";

import { FormulariPrincipal }  from "../Component/Evaluacion/FormulariPrincipal";
import { MenuPrincipal }       from "../Component/MenuPrincipal/MenuPrincipal";
import { MenuPrincipalADMIN }  from "../Component/MenuPrincipal/MenuPrincipalADMIN";
import { AdminLayout }         from "../Component/ui/AdminLayout";
import { Resultats }           from "../Component/MenuPrincipal/Resultats/Resultats";
import { ModificarScreen }     from "../Component/register/ModificarScreen";
import { FooterPublic }        from "../Component/ui/FooterPublic";
import { HeaderPrivat }        from "../Component/ui/HeaderPrivat";
import FormularioAdmin         from "../Component/ModificarFormulario/FormularioAdmin";
import { UserLayout } from "../Component/ui/UserLayout";

export const DashboardRoutes = () => {
    const { auth } = useSelector(state => state);

    // UN solo estado para toda la navegación admin
    // 'historial' | 'usuarios' | 'municipios' | 'textos' | 'constantes' | 'indicadores'
    const [vista, setVista] = useState('historial');

    return (
        <>
        <HeaderPrivat />
        <div id="cos">
            {auth.admin == 0 ?
            <Routes>
                <Route path="/" element={
                    <UserLayout>
                        <MenuPrincipal />
                    </UserLayout>
                } />
                <Route path="/menu" element={
                    <UserLayout>
                        <MenuPrincipal />
                    </UserLayout>
                } />
                <Route path="/modificar"  element={
                    <UserLayout>
                    <ModificarScreen />
                    </UserLayout>} />
                <Route path="/evaluacion" element={<UserLayout><FormulariPrincipal /></UserLayout>} />
                <Route path="/resultats"  element={<UserLayout><Resultats /></UserLayout>} />
            </Routes>
            :
            <Routes>
                <Route path="/" element={
                    <AdminLayout vista={vista} onCambiarVista={setVista}>
                        <MenuPrincipalADMIN vista={vista} onCambiarVista={setVista} />
                    </AdminLayout>
                } />
                <Route path="/menu" element={
                    <AdminLayout vista={vista} onCambiarVista={setVista}>
                        <MenuPrincipalADMIN vista={vista} onCambiarVista={setVista} />
                    </AdminLayout>
                } />
                <Route path="/evaluacion" element={
                    <AdminLayout vista={vista} onCambiarVista={setVista}>
                        <FormularioAdmin vista={vista} />
                    </AdminLayout>
                } />
                <Route path="/resultats" element={
                    <AdminLayout vista={vista} onCambiarVista={setVista}>
                        <Resultats />
                    </AdminLayout>
                } />
            </Routes>
            }
        </div>
        <FooterPublic />
        </>
    );
};